
import { supabase } from '@/integrations/supabase/client';
import { WizardFormData } from '../types';

export const useAccountSubmit = () => {
  const createAccount = async (
    formData: WizardFormData, 
    leadAccountId: string, 
    strategyId: string
  ) => {
    if (!formData.account || !leadAccountId || !strategyId) {
      return false;
    }

    const { error: accountError } = await supabase
      .from('account')
      .insert([{
        external_id: formData.account.externalId,
        performance_url: formData.account.performanceUrl,
        is_primary: formData.account.isPrimary,
        active: formData.account.isActive,
        exchange: formData.account.exchange || 'binance', // Default value
        lead_account_id: leadAccountId,
        strategy_id: strategyId
      }]);
      
    if (accountError) {
      throw new Error(`Error creating account: ${accountError.message}`);
    }
    
    return true;
  };

  return { createAccount };
};
